import GenericRepository from "./GenericRepository";
import store from "../store";

export default {
    /**
     * Return last data of an asset.
     * @return {string}
     */
    getLastAssetDtd() {
        return GenericRepository.get(process.env.VUE_APP_FOURDATA_API_BASE_URL + "/api/v1/asset/" + store.getters["maintenance/get"].cuve.uid + "/device_traited_data/latest", {
                headers: {
                    Authorization: `Basic ${store.getters["authentication/user_uid"]}`
                }
            }
        )
    },

    getInstallationCheck() {
        return GenericRepository.get(process.env.VUE_APP_FOURDATA_API_BASE_URL + "/api/v1/asset/" + store.getters["maintenance/get"].cuve.uid + "/device_traited_data/installationCheck", {
                headers: {
                    Authorization: `Basic ${store.getters["authentication/user_uid"]}`
                }
            }
        )
    },

    getAssetDetail() {
        return GenericRepository.get(process.env.VUE_APP_FOURDATA_API_BASE_URL + "/api/v1/asset/" + store.getters["maintenance/get"].cuve.uid + "/detail_maintenance")
    },

    updateOffset(newOffset: number) {
        return GenericRepository.put(process.env.VUE_APP_FOURDATA_API_BASE_URL + "/api/v1/asset/" + store.getters["maintenance/get"].cuve.uid + "/offset", { offset: newOffset }, {
                headers: {
                    Authorization: `Basic ${store.getters["authentication/user_uid"]}`
                }
            }
        )
    }
};
